import {
  IonContent,
  IonHeader,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonItem,
  IonLabel,
  IonList,
  IonLoading,
  IonPage,
  IonRouterLink,
} from '@ionic/react'
import { format, parseISO } from 'date-fns'

import { useInfiniteData } from '../../hooks/use-infinite-data'
import Header from '../../components/header'
import {
  ListItemHeading,
  ListItemSubHeading,
} from '../../components/ui/list-item'
import { useClientImports } from './queries'
function ClientImportsPage() {
  const clientImports = useClientImports()
  const clientImportsFlat = clientImports.data?.pages.flatMap((x) => x.data)

  const [ref, loadMore] = useInfiniteData(clientImports.fetchNextPage)

  return (
    <IonPage>
      <IonHeader>
        <Header title="Client Imports" btn={null} showMenu />
      </IonHeader>
      <IonContent>
        {clientImportsFlat?.length ? (
          <>
            <IonList>
              {clientImportsFlat.map((c) => (
                <IonItem key={c.objectId}>
                  <IonLabel className="ml-4">
                    <IonRouterLink routerLink={'/admin/import/' + c.objectId}>
                      <ListItemHeading secondary>
                        Created:{' '}
                        {c.createdAt
                          ? format(parseISO(c.createdAt.iso), 'MM/dd/yy')
                          : ''}
                      </ListItemHeading>
                      <ListItemSubHeading>
                        Total Clients Imported: {c.clientCount || 0}
                      </ListItemSubHeading>
                      <ListItemSubHeading>
                        File: {c.filename || ''}
                      </ListItemSubHeading>
                    </IonRouterLink>
                  </IonLabel>
                </IonItem>
              ))}
            </IonList>

            <IonInfiniteScroll
              ref={ref}
              onIonInfinite={loadMore}
              threshold="100px"
              disabled={!clientImports.hasNextPage}
            >
              <IonInfiniteScrollContent
                loadingSpinner="bubbles"
                loadingText="loading more campaigns..."
              />
            </IonInfiniteScroll>
          </>
        ) : (
          <div>No client imports found</div>
        )}
      </IonContent>

      <IonLoading isOpen={clientImports.isLoading} message={'Loading...'} />
    </IonPage>
  )
}

export { ClientImportsPage }
